export default "__VITE_ASSET__BZMB$HFj__"